import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { SetorService } from '../setor.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-setores',
  templateUrl: './listar-setores.component.html',
  styleUrls: ['./listar-setores.component.css']
})
export class ListarSetoresComponent implements OnInit {

  filtroPesquisaNomeSetor: string;

  setoresCliente: SetorCliente[];

  paginacao: Paginacao;

  evento: Evento;

  selecionados: boolean;
  statusCode: number;

  public loading = false;

  constructor(private _setorService: SetorService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.setoresCliente = new Array<SetorCliente>();
    this.evento = this._comumService.evento;

    if (this.evento !== undefined) {
      setTimeout(() => { this._comumService.cleanEvent(); }, 2000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;
    const idCliente = parseInt(this._cookieService.get('idCliente'));
    const sc = this._setorService.obterSetoresClienteHttp(idCliente);
    const s = this._setorService.obterSetoresHttp();

    forkJoin(s, sc)
      .subscribe(([setores, setoresCliente]) => {
        for (const setor of setores) {
          const novoSetorCliente = new SetorCliente();
          novoSetorCliente.setor = setor;
          novoSetorCliente.idCliente = idCliente;
          for (const setorCliente of setoresCliente) {
            novoSetorCliente.pontosFisicosVinculados = 0;
            if (setorCliente.setor.idSetor === setor.idSetor) {
              novoSetorCliente.pontosFisicosVinculados = setorCliente.pontosFisicosVinculados;
              novoSetorCliente.idSetorCliente = setorCliente.idSetorCliente;
              novoSetorCliente.selecionado = true;
              break;
            }
          }
          self.setoresCliente.push(novoSetorCliente);
        }
        self.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeSetor = filtro.value;
  }

  selecionar(setorCliente: SetorCliente, event): void {
    if (setorCliente.selecionado && setorCliente.idSetorCliente !== null
      && setorCliente.idSetorCliente !== undefined && setorCliente.pontosFisicosVinculados > 0) {
      this.confirmationService.confirm({
        message: 'Precisa desvincular ao Ponto F\u00edsico',
        rejectVisible: false,
        accept: () => {
          event.target.checked = true;
        },
        reject: () => {
          event.target.checked = true;
        }
      });
    } else {
      setorCliente.selecionado = !setorCliente.selecionado;
      setorCliente.alterado = true;
    }
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    if (!this.selecionados) {
      for (let i = 0; i < this.setoresCliente.length; i++) {
        if (this.setoresCliente[i].pontosFisicosVinculados > 0) {
          this.confirmationService.confirm({
            message: 'Precisa desvincular ao Ponto F\u00edsico',
            rejectVisible: false,
            accept: () => {
            },
            reject: () => {
            }
          });
          break;
        }
      }
    } else {
      this.setoresCliente.forEach(setorCliente => {
        setorCliente.selecionado = this.selecionados;
        setorCliente.alterado = true;
      });
    }
  }

  removerSetor(setorCliente: SetorCliente): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o setor?',
      accept: () => {
        this.loading = true;
        this._setorService.removerSetorHttp(setorCliente.setor.idSetor).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerSetorFromList(this.setoresCliente, setorCliente);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });
  }

  removerSetorFromList(setoresCliente: SetorCliente[], setorCliente: SetorCliente): void {
    const index = this.obterIdSetorCliente(setoresCliente, setorCliente);
    setoresCliente.splice(index, 1);
  }

  obterIdSetorCliente(setoresCliente: SetorCliente[], setorCliente: SetorCliente): number {
    return setoresCliente.indexOf(setorCliente);
  }

  onSubmit(): void {
    this.loading = true;
    const setoresClienteInsert = new Array<SetorCliente>();
    const setoresClienteRemove = new Array<SetorCliente>();
    this.setoresCliente.forEach(setorCliente => {
      if (!setorCliente.selecionado && setorCliente.idSetorCliente !== undefined && setorCliente.alterado) {
        setoresClienteRemove.push(setorCliente);
      } else if (setorCliente.selecionado && setorCliente.idSetorCliente === undefined
        && setorCliente.alterado) {
        setoresClienteInsert.push(setorCliente);
      }
    });
    if (setoresClienteRemove.length > 0) {
      this._setorService.removerSetoresClienteHttp(setoresClienteRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-setores']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (setoresClienteInsert.length > 0) {
      this._setorService.cadastrarSetoresClienteHttp(setoresClienteInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-setores']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/listar-setores/listar-setores.component.ts